/**
 * 资产校准设置
 */
import http from '@/http'

export default {
  // 查询校准列表
  getCalibrationList(params) {
    return http.get('/calibration/setting', { params })
  },
  // 查询校准记录列表
  getCalibrationRecordList(params) {
    return http.get('/calibration/record/page', { params })
  },
  // 查询校准记录详情
  getCalibrationRecordDetail(id) {
    return http.get(`/calibration/record/${id}`)
  },
  // 编辑并保存已有校准记录
  editCalibrationRecord(params) {
    return http.put('/calibration/record/edit', params)
  },
  // 保存校准（新增/编辑）
  saveCalibration(params) {
    return http.post('/calibration/setting', params)
  },
  // 删除校准
  deleteCalibration(params) {
    return http.post('/calibration/setting/delete', params)
  },
  // 切换校准状态（启用/禁用）
  toggleStatus(params) {
    return http.post('/calibration/setting/enable', params)
  },
  // 校准记录 按工段统计(总数/正常/异常/已逾期)
  getCalibrationRecordStationStatistics(params) {
    return http.get('/calibration/record/station-statistics', { params })
  },
  // 手动立即生成校准任务（系统每日也会自动生成）
  generateCalibrationTasks() {
    return http.post('/calibration/task/generate')
  }
}
